import PropTypes from 'prop-types';
import { useState } from 'react';
import { BiAccessibility } from 'react-icons/bi';
import AnimatedIcon from './AnimatedIcon.jsx';
import './AccessibilityBar.css';

const textSizeOptions = [
  { value: 'base', label: 'Default', sampleScale: 1 },
  { value: 'large', label: 'Large', sampleScale: 1.2 },
  { value: 'larger', label: 'Larger', sampleScale: 1.35 },
  { value: 'largest', label: 'Largest', sampleScale: 1.5 },
];

const AccessibilityBar = ({ accessibility, setAccessibility, inline = false }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleOption = (key) => {
    setAccessibility((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const setTextSize = (value) => {
    setAccessibility((prev) => ({
      ...prev,
      textSize: value,
    }));
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <div
      className={`accessibility-bar ${inline ? 'accessibility-bar--inline' : ''}`}
      aria-label="Accessibility preferences"
    >
      <button
        type="button"
        className="accessibility-menu-trigger"
        onClick={toggleMenu}
        aria-expanded={isMenuOpen}
        aria-label="Toggle accessibility menu"
      >
        <BiAccessibility aria-hidden="true" />
      </button>
      
      {isMenuOpen && (
        <div className="accessibility-menu-dropdown" role="menu">
          <div className="accessibility-menu-section" role="group" aria-label="Text size">
            <span className="accessibility-menu-heading">Text size</span>
            <div className="accessibility-text-options">
              {textSizeOptions.map((option) => (
                <button
                  type="button"
                  key={option.value}
                  className={`accessibility-btn accessibility-btn--compact ${
                    accessibility.textSize === option.value ? 'active' : ''
                  }`}
                  onClick={() => setTextSize(option.value)}
                  aria-pressed={accessibility.textSize === option.value}
                >
                  <span
                    className="accessibility-text-sample"
                    style={{ fontSize: `${option.sampleScale}rem` }}
                    aria-hidden="true"
                  >
                    A
                  </span>
                  <span>{option.label}</span>
                </button>
              ))}
            </div>
          </div>
          <div className="accessibility-menu-section" role="group" aria-label="Additional accessibility preferences">
            <button
              type="button"
              className={`accessibility-btn ${accessibility.highContrast ? 'active' : ''}`}
              onClick={() => toggleOption('highContrast')}
              aria-pressed={accessibility.highContrast}
            >
              <AnimatedIcon name="contrast" />
              <span>High Contrast</span>
            </button>
            <button
              type="button"
              className={`accessibility-btn ${accessibility.reduceMotion ? 'active' : ''}`}
              onClick={() => toggleOption('reduceMotion')}
              aria-pressed={accessibility.reduceMotion}
            >
              <AnimatedIcon name="motion" />
              <span>Reduce Motion</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

AccessibilityBar.propTypes = {
  accessibility: PropTypes.shape({
    textSize: PropTypes.string,
    highContrast: PropTypes.bool,
    reduceMotion: PropTypes.bool,
  }).isRequired,
  setAccessibility: PropTypes.func.isRequired,
  inline: PropTypes.bool,
};

export default AccessibilityBar;
